import React from 'react';
import { ConfirmDialog } from '../../../../components/confirm-dialog';

interface IExistingLessonsDialogProps {
  onClose: () => void;
}

export function ExistingLessonsDialog({ onClose }: IExistingLessonsDialogProps) {
  return (
    <ConfirmDialog title="Fremmødeforløbet kan ikke oprettes" type="alert" open onConfirmClick={onClose} confirmButtonText="Ok">
      <p>Borgeren har allerede lektioner på dette hold i den valgte periode.</p>
    </ConfirmDialog>
  );
}
